"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryToCreateDataIterator = exports.registerDataIteratorFactory = exports.DataIterator = void 0;
const base_1 = require("./base");
Object.defineProperty(exports, "DataIterator", { enumerable: true, get: function () { return base_1.DataIterator; } });
const dataIteratorFactoryRef = {};
function registerDataIteratorFactory(factory) {
    dataIteratorFactoryRef.current = factory;
}
exports.registerDataIteratorFactory = registerDataIteratorFactory;
function tryToCreateDataIterator(data, chunkSize, threshold) {
    var _a;
    return (_a = dataIteratorFactoryRef.current) === null || _a === void 0 ? void 0 : _a.call(dataIteratorFactoryRef, data, chunkSize, threshold);
}
exports.tryToCreateDataIterator = tryToCreateDataIterator;
